import { render, staticRenderFns } from "./PatientAdd.vue?vue&type=template&id=37f3ee5e"
import script from "./PatientAdd.vue?vue&type=script&lang=js"
export * from "./PatientAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports